const cCertificate = () => {

  let idle = true;
  let initialized = false;
  let lastShineAnimateTime = 0;
  let canAnimateShine = true;
  const card = document.querySelector('.certificate__card');
  const light = document.querySelector('.certificate__light');

  if (!card) return;

  const {height, width} = card.getBoundingClientRect();

  card.addEventListener('mousemove', (event) => {
    idle = false;
    if (Date.now() - lastShineAnimateTime > 3000 && canAnimateShine) {
      lastShineAnimateTime = Date.now();
      canAnimateShine = false;
      card.classList.add('animateShine');
      setTimeout(() => {
        card.classList.remove('animateShine');
      }, 750);
    } else {
      canAnimateShine = false;
    }

    const xOffset = (event.layerX - width / 2) / width;
    const yOffset = (event.layerY - height / 2) / height;
    idleRotation = Math.atan2(yOffset, xOffset);
    rotateCard(xOffset, yOffset);
  });

  let lightRotation = null;
  const rotateCard = (xOffset, yOffset) => {
    const yRotation = 10 * xOffset;
    const xRotation = -10 * yOffset;
    card.style.transform = `
        		perspective(500px) rotateX(${xRotation}deg) rotateY(${yRotation}deg)
        	`;
    const rotation = (Math.atan2(-xOffset, yOffset) * 180) / Math.PI + Math.floor((lightRotation || 0) / 360) * 360;
    if (lightRotation === null) {
      lightRotation = Math.round(rotation);
    } else {
      let diff = Math.round(rotation) - lightRotation;
      if (diff) {
        if (diff < -180) {
          diff += 360;
        }
        lightRotation += diff;
      }
    }
    light.style.transform = `translateY(-34.375%) translateX(-25%) rotate(${lightRotation}deg)`;
    if (!initialized) {
      initialized = true;
      setTimeout(() => {
        document.body.classList.add('initialized');
      }, 0);
    }
  };

  card.addEventListener('mouseout', function () {
    canAnimateShine = true;
    idle = true;
    prevTime = Date.now();
    idleAnimation();
  });

  let prevTime = Date.now();
  let idleRotation = 0;
  const idleAnimation = () => {
    const time = Date.now();
    const dt = time - prevTime;
    prevTime = time;

    const prevRotation = idleRotation;
    idleRotation += (Math.PI / 4) * (dt / 1000);
    const x = Math.cos(idleRotation);
    const y = Math.sin(idleRotation);
    rotateCard(x / 2, y / 2);

    if (idle) {
      window.requestAnimationFrame(idleAnimation);
    }
  };

  window.requestAnimationFrame(idleAnimation);
}

export default cCertificate
